let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jihoE")).then(() => parcelRequire('hTcRh'));